import { useCallback } from "react";
import { useDisconnect } from "wagmi";
import { useHistory, useLocation } from "react-router-dom";

import { SHOULD_EAGER_CONNECT_LOCALSTORAGE_KEY, CURRENT_PROVIDER_LOCALSTORAGE_KEY } from "config/localStorage";
import { useGmxAccountModalOpen } from "context/GmxAccountContext/hooks";
import { useSettings } from "context/SettingsContext/SettingsContextProvider";
import { userAnalytics } from "lib/userAnalytics";
import { DisconnectWalletEvent } from "lib/userAnalytics/types";

export function useDisconnectAndClose() {
  const { setIsSettingsVisible } = useSettings();
  const [, setIsVisible] = useGmxAccountModalOpen();
  const { disconnect } = useDisconnect();
  const history = useHistory();
  const location = useLocation();

  const handleDisconnect = useCallback(() => {
    disconnect();
    userAnalytics.pushEvent<DisconnectWalletEvent>({
      event: "ConnectWalletAction",
      data: {
        action: "Disconnect",
      },
    });
    disconnect();
    localStorage.removeItem(SHOULD_EAGER_CONNECT_LOCALSTORAGE_KEY);
    localStorage.removeItem(CURRENT_PROVIDER_LOCALSTORAGE_KEY);
    setIsVisible(false);
    setIsSettingsVisible(false);

    // If on accounts page, redirect to /accounts to show connect wallet prompt
    if (location.pathname.startsWith("/accounts")) {
      setTimeout(() => {
        history.push("/accounts");
      }, 1000);
    }
  }, [disconnect, setIsVisible, setIsSettingsVisible, history, location]);

  return handleDisconnect;
}
